import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

const SEARCH_INPUT_WIDTH_PX = 400;
const SEARCH_INPUT_MIN_WIDTH_PX = 200;

export const tableFiltersWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
});

export const tableFiltersWrapperRowClass = style({
  display: 'flex',
  gap: spacingVars.xl,
  minWidth: 0,
});

export const tableFiltersRowClass = style({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: spacingVars.lg,
  marginBottom: spacingVars['2xl'],
  flexWrap: 'wrap',
  selectors: {
    /*
      The active filters row is only rendered when at least one filter is
      applied: while it is there it owns the spacing down to the table, so the
      search row only needs the tighter gap towards it.
    */
    '&:not(:last-child)': {
      marginBottom: spacingVars.lg,
    },
  },
});

export const searchInputClass = style({
  width: SEARCH_INPUT_WIDTH_PX,
  flexShrink: 1,
  minWidth: SEARCH_INPUT_MIN_WIDTH_PX,
});

export const tableTopBarActionsClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.md,
});

export const inlineActiveFiltersClass = style({
  selectors: {
    [`${tableFiltersWrapperRowClass} &`]: {
      marginBottom: 0,
    },
  },
});
